export const myTest = {
    "my_test_type": "Loại bài thi",
    "test_result": "Kết quả bài thi",
};
